const moodResponses = {
  great: {
    empathy: "It's wonderful that you're feeling great today. That positive energy is something to celebrate.",
    encouragement: "You're in a great headspace right now. This is the perfect time to appreciate what's going well and maybe share that joy with someone.",
    coping_tip: "Capture this feeling by doing something you love—whether it's creating, moving, or connecting with others. These moments fuel us.",
    reflection_question: "What's one thing that contributed most to your great mood today?"
  },
  good: {
    empathy: "Feeling good is a solid place to be. You're managing well and that's worth acknowledging.",
    encouragement: "You've got a steady, positive vibe going. Keep nurturing what's working for you.",
    coping_tip: "Notice what's helping you feel good right now. Is it something you did, someone you're with, or just how you're taking care of yourself?",
    reflection_question: "What's one small thing you could do more of to keep this good feeling going?"
  },
  okay: {
    empathy: "Feeling okay is completely normal. Not every day needs to be extraordinary—sometimes steady is exactly what we need.",
    encouragement: "You're showing up and checking in with yourself. That's a sign of self-awareness and strength.",
    coping_tip: "Try a small shift: a 5-minute walk, a cup of tea, or a few deep breaths. Sometimes a tiny change can shift the whole vibe.",
    reflection_question: "Is there one thing that would make today feel a bit better for you?"
  },
  stressed: {
    empathy: "Stress is your mind and body telling you something matters to you. That's actually a sign of caring and engagement.",
    encouragement: "You're handling more than you might realize. The fact that you're checking in shows you're taking your well-being seriously.",
    coping_tip: "Break what's stressing you into smaller pieces. You don't have to solve everything at once. Pick one small thing you can control.",
    reflection_question: "What's one thing you could let go of or delegate today to ease some pressure?"
  },
  overwhelmed: {
    empathy: "Feeling overwhelmed means you're carrying a lot right now. That's real, and it's okay to feel the weight of it.",
    encouragement: "You reached out and checked in with yourself—that's a powerful first step. You're not alone in this.",
    coping_tip: "Pause. Just for a moment. Take three slow breaths. Then pick ONE thing—just one—that you can do right now. Everything else can wait.",
    reflection_question: "What's the smallest, most manageable thing you could do in the next hour to feel a bit lighter?"
  }
};

const stressResponses = {
  high: {
    empathy: "High stress is exhausting. Your nervous system is working overtime, and that takes real energy.",
    encouragement: "You're still here, still trying, still reaching out. That resilience matters more than you know.",
    coping_tip: "Ground yourself: feel your feet on the floor, notice 5 things you can see. Bring yourself back to the present moment.",
    reflection_question: "What's one thing that usually helps you feel calmer when stress is high?"
  },
  medium: {
    empathy: "You're in that middle space where things feel manageable but still present. That's a good place to pause and reset.",
    encouragement: "You're balancing a lot. Recognizing your stress level is the first step to managing it.",
    coping_tip: "A short break can work wonders. Even 10 minutes of something you enjoy can help reset your nervous system.",
    reflection_question: "What's one boundary you could set today to protect your energy?"
  },
  low: {
    empathy: "You're in a calm, grounded place right now. That's a gift—enjoy it.",
    encouragement: "You're managing your stress well. Keep doing what you're doing.",
    coping_tip: "Use this calm moment to do something preventative—maybe plan something you enjoy or connect with someone you care about.",
    reflection_question: "What's helping you stay calm right now? How can you do more of it?"
  }
};

export function generateMockResponse(mood, stress, thoughts) {
  const stressCategory = stress >= 8 ? 'high' : stress >= 5 ? 'medium' : 'low';
  const moodData = moodResponses[mood] || moodResponses.okay;
  const stressData = stressResponses[stressCategory];

  return {
    empathy: moodData.empathy,
    encouragement: moodData.encouragement,
    coping_tip: moodData.coping_tip,
    reflection_question: moodData.reflection_question,
    stress_insight: stressData.empathy,
    timestamp: new Date().toLocaleTimeString(),
    date: new Date().toLocaleDateString()
  };
}
